import React from 'react';
import { Box } from 'grommet';
import PropTypes from 'prop-types';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import { BlockId } from './BlockIdExtension';
import {
    EntryHeader,
    EntryHeaderName,
    EntryHeaderDate,
    EntryDateParagraph,
} from './EntryHeaderExtension';
import { RESUME_VIEWER_STYLES } from './resumeDocumentStyles';

export const ResumeContentViewer = ({ content }) => {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Highlight,
            TextAlign.configure({ types: ['heading', 'paragraph'] }),
            BlockId,
            EntryHeader,
            EntryHeaderName,
            EntryHeaderDate,
            EntryDateParagraph,
        ],
        content: content || '',
        editable: false,
    });

    return (
        <Box
            background="white"
            round="6px"
            border={{ color: 'enrich-green-light', size: '3px' }}
            pad="small"
            width="100%">
            <style>{RESUME_VIEWER_STYLES}</style>
            <EditorContent editor={editor} />
        </Box>
    );
};

ResumeContentViewer.propTypes = {
    content: PropTypes.string,
};
